export default "__VITE_ASSET__zFk7ihUo__"